module.exports = __webpack_public_path__ + "static/media/bonus.427d53cb.svg";